module.exports = __webpack_public_path__ + "img/2.552fae76.png";